import Image from 'next/image';

import { blurDataURL } from '@/shared/lib';

export default function PreviewPost({
  content,
  file,
  coverPictureOwnerAttribute
}: {
  content: string;
  file: (File & { preview: string }) | null;
  coverPictureOwnerAttribute: string | null;
}) {
  return (
    <section className="rounded-md bg-slate-700 p-6 drop-shadow-md dark:shadow-slate-100">
      {file && (
        <>
          <Image
            className="m-auto h-auto rounded-sm pb-8"
            alt={file.name}
            src={file.preview}
            width={1920 / 3}
            height={1280 / 3}
            quality={10}
            loading="lazy"
            placeholder="blur"
            blurDataURL={blurDataURL}
            sizes="(max-width: 768px) 45vw, 50vw"
            onLoad={() => {
              URL.revokeObjectURL(file.preview);
            }}
          />
          {coverPictureOwnerAttribute && (
            <span
              dangerouslySetInnerHTML={{
                __html: coverPictureOwnerAttribute
              }}
            />
          )}
        </>
      )}
      <article
        className="container"
        dangerouslySetInnerHTML={{
          __html: content
        }}
      />
    </section>
  );
}
